import React from "react"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

const ContentDataTitle = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 1.3em;
  /* line-height: 30px; */
  /* or 62% */

  color: #0f6494;
  margin-bottom: 20px;

  text-transform: uppercase;

  ${breakpoint.sm} {
    font-size: 1.5em;
  }

  ${breakpoint.lg} {
    font-size: 1.9em;
  }
`

const StyledIconAndIconTextWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 5px;

  ${breakpoint.lg} {
    margin-bottom: 10px;
  }
`

const ContentDataDescription = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1.1em;

  color: #414042;

  ${breakpoint.sm} {
    font-size: 1.2em;
  }

  ${breakpoint.lg} {
    font-size: 1.4em;
  }
`

const StyledImg = styled.img`
  margin-bottom: 0px;
  height: 60px;

  ${breakpoint.lg} {
    height: 71px;
  }
`

const ContentDataIconWrapper = styled.div`
  margin-right: 30px;
`

const ContentDataIconText = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 3.8em;
  line-height: 1.4;

  color: #0f6497;

  ${breakpoint.lg} {
    font-size: 4.2em;
  }
`

const ContentDataItem = props => {
  return (
    <>
      <ContentDataTitle>{props.title}</ContentDataTitle>
      <StyledIconAndIconTextWrapper>
        <ContentDataIconWrapper>
          <StyledImg src={props.iconSrc} alt={props.iconDescription} />
        </ContentDataIconWrapper>
        <ContentDataIconText>{props.iconText}</ContentDataIconText>
      </StyledIconAndIconTextWrapper>
      <ContentDataDescription>{props.children}</ContentDataDescription>
    </>
  )
}

export default ContentDataItem
